export default __webpack_public_path__ + "7027f105489e555d2f4f915770413a56.svg";